import React, { useEffect, useState } from 'react'

interface ParallaxLayoutProps {
  children: React.ReactNode
}

export const ParallaxLayout: React.FC<ParallaxLayoutProps> = ({ children }) => {
  const [offset, setOffset] = useState(0)

  useEffect(() => {
    const handleScroll = () => {
      setOffset(window.scrollY)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <div className="relative min-h-screen overflow-hidden" style={{ backgroundColor: '#00A3B0' }}>
      {/* Parallax Background Layer */}
      <div
        className="fixed inset-0 z-0 w-full h-[120%] pointer-events-none"
        style={{
          transform: `translateY(-${offset * 0.3}px)`,
          backgroundImage: 'url(/Background_1500x.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center top',
          backgroundRepeat: 'no-repeat',
        }}
      />

      {/* Gradient fade overlay - creates smooth transition when scrolling past background */}
      <div 
        className="fixed inset-0 z-0 pointer-events-none"
        style={{
          background: 'linear-gradient(to bottom, transparent 0%, transparent 50%, rgba(0, 163, 176, 0.5) 75%, rgba(0, 163, 176, 0.95) 100%)',
        }}
      />

      {/* Overlay for readability if needed, but keeping it airy as per PRD */}
      <div className="fixed inset-0 z-0 bg-white/10 pointer-events-none mix-blend-overlay" />

      {/* Content Layer */}
      <div className="relative z-10 min-h-screen flex flex-col">
        {children}
      </div>
    </div>
  )
}
